import {
  FETCH_OMNITRON_ORDERS_PENDING,
  FETCH_OMNITRON_ORDERS_REJECTED,
  FETCH_OMNITRON_ORDERS_FULFILLED,
} from 'constants/kapidaConstants/omnitronOrders';

const initialState = {
  pending: true,
  omnitronOrders: {},
  error: {},
};

export const omnitronOrders = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OMNITRON_ORDERS_PENDING:
      return { ...state, pending: true, error: {} };

    case FETCH_OMNITRON_ORDERS_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_OMNITRON_ORDERS_FULFILLED:
      return {
        ...state,
        omnitronOrders: action.data,
        pending: false,
        error: {},
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/omnitronOrders.js